import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services';
import { switchMap, take } from 'rxjs';
import { UserService } from '../../../dashboard/services';

@Component({
  selector: 'kt-app-login',
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private userService = inject(UserService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  @Input() cssClass!:string;

   /** NEW */
  @Input() redirectUrl: string | null = '/dashboard/overview';
  @Input() closeOnSuccess = false;

  /** NEW EVENTS */
  @Output() loginSuccess = new EventEmitter<void>();
  @Output() forgotPassword = new EventEmitter<void>();
  @Output() createAccount = new EventEmitter<void>();
  @Output() loginError = new EventEmitter<string>();

  loading = false;
  error: string | null = null;

  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
    remember: ['']
  });

  get email(){
    return this.loginForm.controls['email'].value();
  }

  get password(){
    return this.loginForm.controls['password'].value();
  }

  onSubmit(): void{
    if(this.loginForm.invalid || this.loading){
      this.loginForm.markAllAsTouched();
      return;
    }

    const {email, password, remember} = this.loginForm.value;

    this.authService.login(email!, password!, remember)
      .pipe(
        switchMap(() => {
          return this.userService.getCurrentUser();
        }),
        take(1)
      )
      .subscribe({
        next: () => {
          /** Emit success */
          this.loginSuccess.emit();

          /** Navigate ONLY if redirectUrl is provided */
          if (this.redirectUrl) {
            this.router.navigateByUrl(this.redirectUrl);
          }
        },
        error: (err) => {
          console.error('Failed to fetch user details', err);
          this.authService.LoginFailReset();
        }
      });
  }
}
